import Axios from 'axios';
var root = 'https://service-web.szdreamerstech.com/';

const axios = Axios.create();
//请求拦截
axios.interceptors.request.use((config) => {
    //请求之前重新拼装url
    config.url = root + config.url;
    return config;
});

const CancelToken = Axios.CancelToken;
const source = CancelToken.source();
// http request 拦截器
axios.interceptors.request.use(
  config => {
    config.cancelToken = source.token; // 全局添加cancelToken
    return config;
  },
  error => {
    return Promise.reject(error);
  });
axios.interceptors.response.use(
    response => {
        // 登录失效300

        if ( response.data.code===300) {
            // source.cancel(); // 取消其他正在进行的请求(不在使用此方法，因为会把登录请求也取消)
        }
        return response;
    },
    
    error => {
        // if (axios.isCancel(error)) { // 取消请求的情况下，终端Promise调用链
        //     return new Promise(() => {});
        // } else {
        //     return Promise.reject(error);
        // }
    }
);

export default axios;